import { Mail, Phone, User } from "lucide-react";
import { CiLock } from "react-icons/ci";

// ─── Step 1: Amount picker
export const AmountStep = ({
  presetAmounts,
  amount,
  setAmount,
  userData,
  onDonate,
}) => {
  const handleDonate = () => {
    if (!amount || Number(amount) <= 0) {
      alert("Please enter a valid amount");
      return;
    }
    onDonate(Number(amount));
  };

  return (
    <div className="border border-gray-300 w-full py-6 px-4 sm:px-6 bg-donationbgc rounded-md">
      <h2 className="text-center text-2xl sm:text-3xl font-extrabold">
        Donate Now
      </h2>
      <p className="text-center max-w-2xl mx-auto text-donationtext text-sm font-normal lg:text-md mt-2">
        A kind gesture can reach a wound that only compassion can heal.
      </p>

      <div className="pt-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-center">
          {presetAmounts.map((preset) => (
            <button
              key={preset}
              type="button"
              onClick={() => setAmount(preset)}
              className={`p-2 rounded-lg w-full sm:text-md lg:text-lg transition-all ${Number(amount) === preset
                ? "bg-amounthoverColor text-white"
                : "bg-amountbuttonColor hover:bg-amounthoverColor hover:text-white"
                }`}
            >
              ₹{preset}
            </button>
          ))}
        </div>

        <div className="my-4 border border-slate-500 rounded-md">
          <input
            type="number"
            value={amount}
            min={0}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
            className="w-full rounded-lg placeholder:text-center text-black p-3"
          />
        </div>
      </div>

      <button
        onClick={handleDonate}
        className="rounded-md w-full bg-donatebuttonColor flex justify-center items-center py-3"
      >
        <h4 className="text-white text-lg lg:text-xl">Donate Now</h4>
      </button>

      <div className="flex justify-center items-center gap-2 pt-4">
        <CiLock size={20} className="text-lockColor" />
        <h5 className="text-donationtext text-sm lg:text-[15px]">
          100% Secure Donation
        </h5>
      </div>
    </div>
  );
};

// ─── Step 2: Confirm & pay


export const ConfirmStep = ({
  amount,
  onPay,
  loading,
  formData,
  setFormData,
  userData,
}) => {
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="border border-gray-200 w-full mx-auto bg-white rounded-xl shadow-sm p-4 sm:p-5 lg:p-6">
      {/* Header*/}
      <div className="text-center mb-4">
        <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
          Confirm Your Donation
        </h2>
        <p className="text-gray-500 text-xs sm:text-sm mt-1 max-w-xs mx-auto leading-tight">
          Review your details and proceed securely.
        </p>
      </div>

      {/* Amount Card */}
      <div className="mb-5 bg-gray-50 border border-gray-200 rounded-lg p-3 text-center">
        <p className="text-xs text-gray-500">Donation Amount</p>
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mt-1">
          ₹{amount}
        </h3>
      </div>

      {/* USER EXISTS */}
      {userData ? (
        <div className="mb-5 border border-gray-200 rounded-lg p-3 bg-gray-50">
          <p className="text-xs text-gray-500 mb-1 text-center">
            Donating as
          </p>

          <div className="space-y-0.5 text-center">
            <h3 className="text-base font-semibold text-gray-900">
              {userData.name}
            </h3>
            <p className="text-xs text-gray-600">{userData.email}</p>
            <p className="text-xs text-gray-600">
              {userData.phoneNumber}
            </p>
          </div>
        </div>
      ) : (
        <div className="space-y-3 sm:space-y-4 mb-5">
          {/* Name */}
          <div className="space-y-1">
            <label className="text-xs font-medium text-gray-700">
              Full Name
            </label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 h-4 w-4" />
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-[#02323F]/20 focus:border-[#02323F] outline-none transition"
              />
            </div>
          </div>

          {/* Email */}
          <div className="space-y-1">
            <label className="text-xs font-medium text-gray-700">
              Email Address
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 h-4 w-4" />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="your@email.com"
                className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-[#02323F]/20 focus:border-[#02323F] outline-none transition"
              />
            </div>
          </div>

          {/* Phone */}
          <div className="space-y-1">
            <label className="text-xs font-medium text-gray-700">
              Phone Number
            </label>
            <div className="relative">
              <Phone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 h-4 w-4" />
              <input
                type="tel"
                maxLength={10}
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder="Enter phone number"
                className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-[#02323F]/20 focus:border-[#02323F] outline-none transition"
              />
            </div>
          </div>
        </div>
      )}

      {/* CTA */}
      <button
        onClick={onPay}
        disabled={loading}
        className={`w-full py-2.5 rounded-md text-sm font-medium text-white transition-all ${loading
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-[#02323F] hover:bg-[#035264]"
          }`}
      >
        {loading ? "Processing..." : `Donate ₹${amount}`}
      </button>

      {/* Security Note */}
      <div className="flex justify-center items-center gap-1.5 mt-4">
        <CiLock size={16} className="text-gray-400" />
        <p className="text-[11px] sm:text-xs text-gray-500">
          Secure payment powered gateway
        </p>
      </div>
    </div>
  );
};
